// services/adminService.js
// Platform admin API calls — requires platform_admin role

import api from '../utils/api';

const adminService = {
  // ── Dashboard ────────────────────────────────────────────────────────────────
  getDashboardStats: () => api.get('/admin/dashboard').then(r => r.data),

  // ── TRY Rate ─────────────────────────────────────────────────────────────────
  getTRYRate: () => api.get('/admin/try-rate').then(r => r.data),

  // ── Invoices ─────────────────────────────────────────────────────────────────
  listInvoices: (params = {}) => api.get('/admin/invoices', { params }).then(r => r.data),
  generateInvoice: (payload) => api.post('/admin/invoices/generate', payload).then(r => r.data),
  markInvoicePaid: (id, payload = {}) => api.post(`/admin/invoices/${id}/mark-paid`, payload).then(r => r.data),
  sendInvoiceReminder: (id) => api.post(`/admin/invoices/${id}/remind`).then(r => r.data),

  // ── Owners ───────────────────────────────────────────────────────────────────
  listOwners: () => api.get('/admin/owners').then(r => r.data),
  blockOwner: (restaurantId, reason) => api.post(`/admin/owners/${restaurantId}/block`, { reason }).then(r => r.data),
  unblockOwner: (restaurantId) => api.post(`/admin/owners/${restaurantId}/unblock`).then(r => r.data),

  // ── Alerts ───────────────────────────────────────────────────────────────────
  listAlerts: () => api.get('/admin/alerts').then(r => r.data),
  createAlert: (payload) => api.post('/admin/alerts', payload).then(r => r.data),
  deleteAlert: (id) => api.delete(`/admin/alerts/${id}`).then(r => r.data),
  dismissAlert: (id) => api.post(`/admin/alerts/${id}/dismiss`).then(r => r.data),

  // ── Analytics ────────────────────────────────────────────────────────────────
  getPageAnalytics: (params = {}) => api.get('/admin/analytics/pages', { params }).then(r => r.data),
  getLandingAnalytics: (params = {}) => api.get('/admin/analytics/landing', { params }).then(r => r.data),
  getOrdersAnalytics: (params = {}) => api.get('/admin/analytics/orders', { params }).then(r => r.data),
  getSaleReports: (params = {}) => api.get('/admin/analytics/sales', { params }).then(r => r.data),
  getEventAnalytics: (params = {}) => api.get('/admin/analytics/events', { params }).then(r => r.data),
  getVisitorAnalytics: (params = {}) => api.get('/admin/analytics/visitors', { params }).then(r => r.data),
  getEngagementAnalytics: (params = {}) => api.get('/admin/analytics/engagement', { params }).then(r => r.data),
  getOwnerActivity: (params = {}) => api.get('/admin/analytics/owner-activity', { params }).then(r => r.data),
  getAnalyticsTrend: (params = {}) => api.get('/admin/analytics/trend', { params }).then(r => r.data),
  getAIUsage: (params = {}) => api.get('/admin/analytics/ai-usage', { params }).then(r => r.data),
};

export default adminService;
